import { ApiErrorResponseFromJSON } from '@ibe/api';
import { action, computed, makeObservable, observable } from 'mobx';
import { removeTrailingSlashes } from '@ibe/services';
import CmsGlobalElements from '../Models/CMS/CmsGlobalElements';

class CmsGlobalElementsService {
  private _apiUrl: string;

  public _globalElements: CmsGlobalElements = new CmsGlobalElements();

  private readonly loadConfigUrl = '/cms/getGlobalElements';

  private _fetchPromise: Promise<CmsGlobalElements> | null = null;

  constructor() {
    makeObservable(this, {
      _globalElements: observable,
      globalElements: computed,
      fetchGlobalElements: action
    });
  }

  get globalElements(): CmsGlobalElements {
    return this._globalElements ? this._globalElements : new CmsGlobalElements();
  }

  set apiUrl(value: string) {
    this._apiUrl = removeTrailingSlashes(value);
  }

  fetchGlobalElements(): Promise<CmsGlobalElements> {
    if (this._fetchPromise) {
      return this._fetchPromise;
    }

    this._fetchPromise = (async () => {
      try {
        const response = await fetch(this._apiUrl + this.loadConfigUrl);
        const jsonResponse = await response.json();
        Object.assign(this._globalElements, jsonResponse);
        return this._globalElements;
      } catch (e) {
        this._fetchPromise = null;
        this._globalElements = new CmsGlobalElements();
        throw ApiErrorResponseFromJSON(e);
      }
    })();

    return this._fetchPromise;
  }
}

export default CmsGlobalElementsService;
